// src/actions/index.js
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const SET_USER = 'SET_USER';
export const SET_MENU = 'SET_MENU';
export const SET_COMPANYS = 'SET_COMPANYS';

export const setUser = (user) => ({
  type: SET_USER,
  payload: user,
});

export const loginSuccess = (user) => ({
  type: LOGIN_SUCCESS,
  payload: user
});

export const loginFailure = (error) => ({
  type: LOGIN_FAILURE,
  payload: error
});

export const setMenu = (menu) => ({
  type: SET_MENU,
  payload: menu,
});

export const setCompanys = (companys) => ({
  type: SET_COMPANYS,
  payload: companys,
});
